import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-100 ml-2 my-6" }
const _hoisted_2 = { class: "w-100 d-flex ml-2 mt-2" }
const _hoisted_3 = { class: "w-25" }
const _hoisted_4 = { class: "text-label-large font-weight-bold" }
const _hoisted_5 = { class: "text-label-large w-100" }
const _hoisted_6 = { class: "w-100 d-flex ml-2 mt-2" }
const _hoisted_7 = { class: "w-25" }
const _hoisted_8 = { class: "text-label-large font-weight-bold" }
const _hoisted_9 = { class: "text-label-large w-100" }
const _hoisted_10 = { class: "w-100 d-flex ml-2 mt-2" }
const _hoisted_11 = { class: "w-25" }
const _hoisted_12 = { class: "text-label-large font-weight-bold" }
const _hoisted_13 = { class: "text-label-large w-100" }
const _hoisted_14 = { class: "w-100 d-flex ml-2 mt-2" }
const _hoisted_15 = { class: "w-25" }
const _hoisted_16 = { class: "text-label-large font-weight-bold" }
const _hoisted_17 = { class: "text-label-large w-100" }
const _hoisted_18 = { class: "w-100 d-flex ml-2 my-2" }
const _hoisted_19 = { class: "w-25" }
const _hoisted_20 = { class: "text-label-large font-weight-bold" }
const _hoisted_21 = { class: "text-label-large w-100" }

import getDeliveryPlanVehicleInformation from '@/types/responses/getDeliveryPlanVehicleInformation';
import { formatDateTime } from '@/services/functions';
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'CombineRollbackContent',
  props: {
    deliveryPlan: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(i18n).global.t('pages.dailyReports.combineRollbackForm.tripId')), 1)
      ]),
      _createElementVNode("div", _hoisted_5, _toDisplayString(props.deliveryPlan.delivery_plan_id), 1)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(i18n).global.t('pages.dailyReports.combineRollbackForm.numberPlate')), 1)
      ]),
      _createElementVNode("div", _hoisted_9, _toDisplayString(props.deliveryPlan.car_number), 1)
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(i18n).global.t('pages.dailyReports.combineRollbackForm.driver')), 1)
      ]),
      _createElementVNode("div", _hoisted_13, _toDisplayString(props.deliveryPlan.driver.full_name), 1)
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(i18n).global.t('pages.dailyReports.combineRollbackForm.leavingWarehouse')), 1)
      ]),
      _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(formatDateTime)(new Date(props.deliveryPlan.leaving_warehouse_date_time))), 1)
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, _toDisplayString(_unref(i18n).global.t('pages.dailyReports.combineRollbackForm.returningWarehouse')), 1)
      ]),
      _createElementVNode("div", _hoisted_21, _toDisplayString(_unref(formatDateTime)(new Date(props.deliveryPlan.returning_warehouse_date_time))), 1)
    ])
  ]))
}
}

})